// extracted by mini-css-extract-plugin
export default {"tooltip-inner":"tooltip-inner_f3fbA","tooltip-inner-image":"tooltip-inner-image_bPdim"};